<template>
  <div class="otm-wrap preReg demo-wrap" v-show="loadComplete">
    <div class="otm-header">
      <div class="inner">
        <h1 class="app-brand">
          <div class="brand-logo">
            <img :src="logo" />
          </div>
          <div class="h1-text">
            <p class="brand-text">{{ title }}</p>
            <p class="test-name">{{ period.name }}</p>
          </div>
        </h1>
      </div>
    </div>
    <div class="otm-body ps" ref="otm-body">
      <div class="main-wrapper active">
        <StepWrapper
          :user="user"
          :step="step"
          :useIdCard="useIdCard"
          :companyName="companyName"></StepWrapper>
      </div>
    </div>
  </div>
</template>

<script>
  import StepWrapper from '@/components/demo/StepWrapper.vue';
  import {mapActions} from 'vuex';
  import api from '@/api';
  import {CUSTOM_COMPANIES} from '@/js/common/constants';
  import {changeScrollStyle} from '@/js/common/util';

  export default {
    name: 'DemoPreRegistration',
    components: {
      StepWrapper,
    },
    metaInfo() {
      return {
        title: this.title,
      };
    },
    data() {
      return {
        loadComplete: false,
        demoUserInfo: null,
        companyId: null,
        companyName: '메사쿠어컴퍼니',
        logo: require('./../../assets/images/icon/h1-logo.png'),
        title: null,
        useIdCard: false,
      };
    },
    async created() {
      const queryParams = new URLSearchParams(location.search);

      // 직능연 관련 정보 세팅
      this.companyId = queryParams.get('cid') || 1;
      const logo = await this.getCompany(this.companyId);
      this.logo = logo;

      this.favicon(this.logo);

      // page title, meta title, logo, 약관 내 회사명
      if (this.companyId == CUSTOM_COMPANIES.KVAI) {
        this.title = this.$t('demo.kRIVETTitle');
        this.companyName = '㈜한국직무능력평가연구소';
      } else if (
        this.companyId == CUSTOM_COMPANIES.GTELP_KOREA ||
        this.companyId == CUSTOM_COMPANIES.GTELP_GLOBAL
      ) {
        this.title = this.$t('demo.gTelpTitle');
        this.companyName = 'G-TELP';
        queryParams.set('idCard', 1);
      } else {
        this.title = this.$t('demo.title');
      }

      // 신분증 등록 기능 사용 여부
      this.useIdCard = queryParams.get('idCard') === '1' ? true : false;

      const demoUser = await api.demoUser();
      this.demoUserInfo = demoUser.data;
      this.$store.commit('user/setUser', this.demoUserInfo);

      if (this.demoUserInfo) {
        try {
          const exam = await this.getExamInfo(this.demoUserInfo.examId);
          this.step = 1;
          this.$emit('on-exam-loaded', exam.theme);
        } catch (error) {
          this.errorModal(error);
          return;
        }
      }

      this.loadComplete = true;
    },
    mounted() {
      changeScrollStyle();
    },
    methods: {
      ...mapActions({
        getExamPeriod: 'user/getExamPeriod',
        getExamInfo: 'user/getExamInfo',
      }),

      async getCompany(id) {
        try {
          const companyInfo = await api.getCompanyLogo(id);
          return companyInfo.data.icon;
        } catch (error) {
          return require('./../../assets/images/icon/h1-logo.png');
        }
      },
    },
    computed: {
      user: {
        get() {
          return this.$store.getters['user/getUser'];
        },
      },
      period() {
        return this.$store.getters['user/getPeriod'];
      },
      exam() {
        return this.$store.getters['user/getExam'];
      },

      step: {
        get() {
          return this.$store.getters['steps/getStep'];
        },
        set(step) {
          this.$store.commit('steps/setStep', step);
        },
      },
    },
  };
</script>
